import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { emitter } from "./bus";
import * as vee from "vee-validate";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";

const app = createApp(App);

app.config.errorHandler = (err, vm, info) => {
  if (String(err).includes("path is undefined")) {
    // Ignore vee-validate field registration error
    return;
  }
  console.error("[Global Error Handler]:", err, info);
};

app.config.warnHandler = (msg, instance, trace) => {
  if (msg.includes("path is undefined")) {
    return;
  }
  console.warn(msg, trace);
};

app.use(store);
app.use(router);
app.use(ElementPlus, null);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

declare module "@vue/runtime-core" {
  export interface ComponentCustomProperties {
    emitter: typeof emitter;
  }
}

app.config.globalProperties.emitter = emitter;
app.mount("#app");
